import { createApp } from 'vue'
import router from './router'
import App from './App.vue'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import store from './store'
import '../src/assets/element.css'
import '../src/assets/assets.css'


// import '../src/static/font_icon/iconfont.css';  
import CommonModal from '@/components/CommonModal'

import "vue3-video-play/dist/style.css";
import vue3VideoPlay from "vue3-video-play";

const app = createApp(App).use(router).use(ElementPlus).use(store).component('CommonModal', CommonModal)
store.commit("getadmindata");
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component)
}
// app.component('es-drager', Drager).component('vue3-video-play', vue3VideoPlay).component('CommonModal', CommonModal).mount('#app')
app.mount('#app')


app.config.silent = true;
